import { render, staticRenderFns } from "./tab-wizard-2.vue?vue&type=template&id=aad2239e&scoped=true"
import script from "./tab-wizard-2.vue?vue&type=script&lang=js"
export * from "./tab-wizard-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad2239e",
  null
  
)

export default component.exports